<template>
    <div>
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <div v-if="parseInt(get_user.verified_status) >= 1">
            <div v-if="congratulation_module">
                <div class="middleBox whitebox border radius mb-3">
                    <div class="congratulations">
                        <div class="logo_congrats">
                            <img src="../../../../static/fxView/images/check.svg" alt="Congratulations" />
                        </div>
                        <div class="subtitle">
                            <h3>
                                {{ $t("rb_congo") }}
                                <span class="green">{{ get_user.profile.firstname }} {{ get_user.profile.lastname
                                    }}</span>
                            </h3>
                            <p>
                                {{ $t("createzullu_Your") }} {{ platform }} {{ $t("createzullu_successcreate") }}
                            </p>
                            <ul class="includeWdth">
                                <li>
                                    <strong> {{ $t("sub_tradingId") }}</strong>
                                    {{ account_detail.account_id }}
                                </li>
                                <li><strong> {{ $t("lg_password") }}</strong>{{ firstChar(account_detail.password) }}
                                </li>
                                <li>
                                    <strong> {{ $t("dash_Leverage") }}</strong>
                                    {{ account_detail.leverage }}
                                </li>
                                <li>
                                    <strong> {{ $t("createzullu_accountBaseCurrency") }}</strong>
                                    {{ account_detail.currency }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="full-width submitButton align-items-center justify-content-center d-flex mt-3 w-100">
                        <a class="prism_btn btn_sm darkBG mr-3" href="#"
                            @click.prevent="congratulation_module = false; reset();">
                            {{ $t("It_back") }}
                        </a>
                        <router-link class="prism_btn btn_sm" to="/account-funding">{{ $t("fund_now") }} </router-link>
                        <!-- <a class="prism_btn btn_sm" href="http://live.actforex.sysfx.com:8100/trade/actlite.jsp?entry=deal.245" target="_blank" v-if="platform == 'ACT'"> {{$t('createzullu_tradenow')}}</a>
                    <router-link class="prism_btn btn_sm"  :to="{path: '/web-trade-link' , query: { 'platformVersion': ((platform.toUpperCase() == 'MT4')? '4' : '5')}}" target="_blank" v-else>{{$t('createzullu_tradenow')}}</router-link> -->
                    </div>
                    <p class="mt-3">{{ $t('fxYouWillReceive') }}</p>
                </div>
                <div class="middleBox whitebox border radius mb-5">
                    <div class="text-center innerTitle pb-3 mb-3">
                        <h2 class="mb-3">{{ $t("dp_download") }} {{ platform }}</h2>
                    </div>
                    <div class="downloadPlatform d-flex align-items-center">
                        <div class="dpBox d-flex align-items-center">
                            <a :href="$env_var.downloadPlatformLink1[platform.toUpperCase()].window" target="_blank">
                                <div class="ico">
                                    <img src="../../../../static/fxView/images/windows.svg" alt="" />
                                </div>
                                <div class="desc">
                                    <p>{{ $t("dp_forWindows") }}</p>
                                </div>
                            </a>
                        </div>
                        <div class="dpBox d-flex align-items-center">
                            <a :href="$env_var.downloadPlatformLink1[platform.toUpperCase()].ios" target="_blank">
                                <div class="ico">
                                    <img src="../../../../static/fxView/images/ios.svg" alt="" />
                                </div>
                                <div class="desc">
                                    <p>{{ $t("dp_forIos") }}</p>
                                </div>
                            </a>
                        </div>
                        <div class="dpBox d-flex align-items-center">
                            <a :href="$env_var.downloadPlatformLink1[platform.toUpperCase()].actLive" target="_blank"
                                v-if="platform == 'ACT'">
                                <div class="ico">
                                    <img src="../../../../static/fxView/images/android.svg" alt="" />
                                </div>
                                <div class="desc">
                                    <p>{{ $t("createzullu_forWeb") }}</p>
                                </div>
                            </a>
                            <router-link :to="{path: $env_var.downloadPlatformLink1.MT4.webTraderInternalLink, query: { 'platform': 'MT4', 'id': account_detail.account_id}}" target="_blank" v-else-if="platform.toUpperCase() == 'MT4'">
                                <div class="ico">
                                    <img src="../../../../static/fxView/images/webtrader.svg" alt="" />
                                </div>
                                <div class="desc">
                                    <p>{{ $t("createzullu_forWeb") }}</p>
                                </div>
                            </router-link>
                            <a
                                title="web_trader"
                                :href="`${$env_var.downloadPlatformLink1.MT5.webliveAccount}${account_detail.account_id}&server=FXView-Live`"
                                target="_blank"
                                v-else>
                                <div class="ico">
                                    <img src="../../../../static/fxView/images/webtrader.svg" alt="" />
                                </div>
                                <div class="desc">
                                    <p>{{ $t("createzullu_forWeb") }}</p>
                                </div>
                            </a>
                            <!-- <router-link
                                :to="{ path: '/web-trade-link', query: { platformVersion: platform.toUpperCase() == 'MT4' ? '4' : '5' } }"
                                target="_blank" v-else>
                                <div class="ico">
                                    <img src="../../../../static/fxView/images/webtrader.svg" alt="" />
                                </div>
                                <div class="desc">
                                    <p>{{ $t("createzullu_forWeb") }}</p>
                                </div>
                            </router-link> -->
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="stepForm">
                    <div class="mainTitle text-center mt-4 mb-3">
                        <h2 class="mb-3">
                            {{ $t("createzullu_open") }} <span>{{$t('fxZulu')}} </span>
                            {{ $t("createzullu_tradingAcc") }}
                        </h2>
                        <message-component :message="response_msg" :messageType="msg_type"
                            v-if="response_msg != ''"></message-component>
                    </div>
                    <div class="middleBox inMiddle-area radius whitebox p-4">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <div class="slctcurrency" v-if="parseInt(get_user.pro_user) == 1">
                                    <h4 class="mb-3">{{ $t("dash_currency") }}</h4>
                                    <ul>
                                        <li :class="select_currency == 'USD' ? 'selected' : ''"
                                            @click.prevent="select_currency = 'USD'">
                                            <img src="../../../../static/fxView/images/usd.svg" alt="usd" />
                                            {{ $t("createzullu_USD") }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="slctcurrency" v-if="parseInt(get_user.pro_user) == 0">
                                    <h4 class="mb-3">{{ $t("dash_currency") }}</h4>
                                    <ul>
                                        <li :class="select_currency == 'USD' ? 'selected' : ''"
                                            @click.prevent="selectCurrencyEvent('USD')">
                                            <img src="../../../../static/fxView/images/usd.svg" alt="usd" />
                                            {{ $t("createzullu_USD") }}
                                        </li>
                                        <li :class="select_currency == 'EUR' ? 'selected' : ''"
                                            @click.prevent="selectCurrencyEvent('EUR')">
                                            <img src="../../../../static/fxView/images/eur.svg" alt="eur" />
                                            {{ $t("createzullu_EUR") }}
                                        </li>
                                        <!-- <li :class="select_currency == 'GBP' ? 'selected' : ''"
                                            @click.prevent="selectCurrencyEvent('GBP')">
                                            <img src="../../../../static/fxView/images/gbp.svg" alt="gbp" />
                                            {{ $t("createzullu_GBP") }}
                                        </li> -->
                                        <li :class="select_currency == 'AUD' ? 'selected' : ''"
                                            @click.prevent="selectCurrencyEvent('AUD')">
                                            <img src="../../../../static/fxView/images/aud.svg" alt="aud" />
                                            {{ $t("createzullu_AUD") }}
                                        </li>
                                        <template>
                                            <li :class="(select_currency == 'ZAR') ? 'selected' : ''"
                                                @click.prevent="selectCurrencyEvent('ZAR')">
                                                <img class="rounded-circle"
                                                    src="../../../../static/fxView/images/zar.svg" alt="zar" />
                                                {{ $t('createzullu_ZAR') }}
                                            </li>
                                            <li :class="(select_currency == 'CAD') ? 'selected' : ''"
                                                @click.prevent="selectCurrencyEvent('CAD')">
                                                <img class="rounded-circle"
                                                    src="../../../../static/fxView/images/cad.svg" alt="cad" />
                                                {{ $t('fxCAD') }}
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-12 mb-3">
                                <input type="hidden" v-model="leverage" v-validate="'required'"
                                    class="float-field form-control"
                                    :class="{ 'is-invalid': submitted && errors.has('leverage') }" ref="leverageInput"
                                    name="leverage" />
                                <div class="slctcurrency">
                                    <h4 class="mb-3">{{ $t("Dlist_leverage") }}</h4>
                                    <ul>
                                        <li :class="leverageDisabledFunc(key)" @click.prevent="leverageSelectFuns(key)"
                                            v-html="key + 'X'" v-for="(list, key) in $env_var.leverageJson"></li>
                                    </ul>
                                    <ul v-if="errors.first('leverage')">
                                        <li class="error">{{ $t("createzullu_leverageField") }}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-12 col-md-12 border-top pt-3">
                                <div class="acPassword">
                                    <h3 class="mb-3">{{ $t("lg_password") }}</h3>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group field-wrapper">
                                            <input :type="inputtype" placeholder=" " v-model="password"
                                                class="float-field form-control"
                                                v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*/])\S{6,15}$/, }"
                                                name="password"
                                                :class="{ 'is-invalid': submitted && errors.has('password') }"
                                                ref="passwordInput" @keyup="testing()" />
                                            <label for="password" class="float-label"> {{
                                            $t("createzullu_accountPassword") }}</label>
                                            <feather :type="iconType" class="toggle-password"
                                                @click.prevent="switchVisibility('1')"></feather>
                                            <p class="error" v-for="error in errors.collect('password')"
                                                v-if="!submitError">
                                                <span v-show="error == 'The password field is required.'">{{
                                                $t("reg_passwordFieldReq") }}</span>
                                                <span v-show="error == 'The password field format is invalid.'">
                                                    {{ $t("cp_passCharval") }}
                                                </span>
                                            </p>
                                            <p class="error" v-if="submitError">
                                                <span>{{ $t("demoacc_passwordMust") }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group field-wrapper">
                                            <input :type="inputtype1" placeholder=" " v-model="confirmPassword"
                                                class="float-field form-control"
                                                v-validate="{ required: true, confirmed: password }"
                                                name="confirmPassword"
                                                :class="{ 'is-invalid': submitted && errors.has('confirmPassword'), }"
                                                ref="confirmPasswordInput" />
                                            <label for="password" class="float-label"> {{ $t("reg_conPassword")
                                                }}</label>
                                            <feather :type="iconType1" class="toggle-password"
                                                @click.prevent="switchVisibility('2')"></feather>
                                            <p class="error" v-for="error in errors.collect('confirmPassword')">
                                                <span v-show="error == 'The confirmPassword field is required.'">
                                                    {{ $t("reg_passwordFieldReq") }}
                                                </span>
                                                <span
                                                    v-show="error == 'The confirmPassword confirmation does not match.'">
                                                    {{ $t("reg_newConfFieldSame") }}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-12 mt-3">
                                <div
                                    class="full-width submitButton justify-content-center align-items-center d-flex mt-3 w-100">
                                    <button class="prism_btn btn_sm" v-on:click.prevent="submit()">
                                        {{ $t("createzullu_createAccount") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- become a pro member -->
                    <!-- <div class="middleBox becomeProMember border-top pt-3" v-if="get_user.pro_user == 0">
                 <router-link :to="'/pro'"><p> {{$t('proMember')}}</p></router-link>
                 </div> -->
                </div>
            </div>
        </div>
        <div v-else>
            <no-trading-account :demo_live_both="'cta'"
                :totalRecords="tradingAccountList.totalLiveAccounts"></no-trading-account>
        </div>
    </div>
</template>

<script>
import { fxViewMixins } from "@/plugins/fxView";
import * as types from "@/types";
import { mapActions } from "vuex";
export default {
    name: "CREATE-ACCOUNT",
    mixins: [fxViewMixins],
    data() {
        return {
            mszValidation: "",
            pageLoader: false,
            submitError: false,
            response_msg: "",
            msg_type: "",
            select_currency: "USD",
            account_type: "CLASSIC",
            platform: "MT4",
            leverage: "500",
            password: "",
            confirmPassword: "",
            error_msg_password: "",
            submitted: false,

            congratulation_module: false,
            account_detail: {},

            inputtype: "password",
            showpassword: false,
            iconType: "eye-off",
            inputtype1: "password",
            showpassword1: false,
            iconType1: "eye-off",
            demo_live_select: "1",
            numberWithCountry: "",
            numberValid: true,
        };
    },
    computed: {
        OnlyUsers() {
            // console.log(this.get_user.profile.user_id);
            return [12832, 12829, 1173].includes(this.get_user.profile.user_id);
        },
    },
    methods: {
        reset() {
            this.password = "";
            this.confirmPassword = "";
        },
        testing() {
            var specialArray = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "_", "-", "+", "=", "[", "]", "{", "}", ";", ":", '"', "/", "?", ".", ">", "<", "|", "/", "*", ","];
            var specialArrayAccept = ["!", "@", "#", "$", "%", "^", "*", "/"];
            let truVar = "";

            for (let i = 0; i <= this.password.length - 1; i++) {
                if (specialArray.indexOf(this.password[i]) > 0) {
                    if (specialArrayAccept.indexOf(this.password[i]) == -1) {
                        truVar = "1";
                    }
                }

                if (i == this.password.length - 1) {
                    if (truVar == "1") {
                        this.submitError = true;
                    } else {
                        this.submitError = false;
                    }
                }
            }
        },
        leverageSelectFuns(getKey) {
                this.$trackEvent('CP+ZuluTrade+Leverage');
            this.leverage = getKey;
        },
        leverageDisabledFunc(getKey) {
            if (parseInt(this.leverage) == parseInt(getKey)) {
                return "selected";
            } else {
                return "";
            }
        },
        updatedText(e) {
            this.numberWithCountry = e.formattedNumber;
            this.numberValid = e.isValid;
        },
        firstChar(getPassword) {
            let first = getPassword.charAt(0);
            let last = getPassword.charAt(getPassword.length - 1);
            return first + "*****" + last;
        },
        switchVisibility(getData) {
            if (getData == "1") {
                this.showpassword = !this.showpassword;
                if (this.showpassword) {
                    this.inputtype = "text";
                    this.iconType = "eye";
                } else {
                    this.inputtype = "password";
                    this.iconType = "eye-off";
                }
            } else {
                this.showpassword1 = !this.showpassword1;
                if (this.showpassword1) {
                    this.inputtype1 = "text";
                    this.iconType1 = "eye";
                } else {
                    this.inputtype1 = "password";
                    this.iconType1 = "eye-off";
                }
            }
        },

        submit() {
            const _that = this;
            _that.submitted = true;
            _that.$validator.validate().then((valid) => {
                if (valid && !_that.submitError) {
                    const plt = _that.platform === "MT4" ? "ZULU" : _that.platform + "-ZULU";
                    let accountJson = {
                        globalParams: {
                            currency: _that.select_currency,
                            account_type: _that.account_type,
                            platform: plt,
                            leverage: _that.leverage,
                            password: _that.password,
                            // 'account_type_zullu' : 'ZULLU',
                            demo_live: _that.demo_live_select.toString(),
                        },
                        localParams: { parameter: _that },
                    };
                        this.$trackEvent('CP+ZuluTrade+Create+account');
                    _that._runCreateAccount(accountJson);
                } else {
                    _that.handleValidationErrorAdvanced(_that.errors);
                }
            });
        },
            trackFzEvent(eventName){
                switch(eventName){
                    case 'Password':
                        this.$trackEvent('CP+ZuluTrade+Password');
                    break;
                }
            },
            selectCurrencyEvent(curncy){
                this.select_currency = curncy;
                this.$trackEvent('CP+ZuluTrade+Currency');
            }
    },
    created() { },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/create_zulu_account.vue